import { ChangeDetectionStrategy, Component } from '@angular/core';
import type { ToastContentInterface } from '@ppl/ui/toast';
import { Subject } from 'rxjs';

@Component({
    selector: 'ppl-two-factor-toast-expired-token',
    templateUrl: './two-factor-toast-expired-token.component.html',
    styleUrls: ['./two-factor-toast-expired-token.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TwoFactorToastExpiredTokenComponent implements
  ToastContentInterface,
  TwoFactorToastExpiredTokenData {

  message: string;
  refresh: TwoFactorToastExpiredTokenRefreshFn;

  closeToast$ = new Subject<null>();

  constructor() { }

  onRefresh() {
    this.closeToast$.next(null);
    this.refresh();
  }

  onClose() {
    this.closeToast$.next(null);
  }

}

type TwoFactorToastExpiredTokenRefreshFn = () => void;

export interface TwoFactorToastExpiredTokenData {
  message: string;
  refresh: TwoFactorToastExpiredTokenRefreshFn;
}
